import Link from 'next/link';

import styles from '@styles/dropAuction/howItWork.module.scss';

const StepOne = () => {
	return (
		<div className='col-sm-4'>
			<div className={styles.howitworkBoxFirst}>
				<div className={styles.stepOne}>
					<div className={styles.loginBox}>
						<div className={styles.stepNumber}>1</div>
						<input
							disabled
							type='text'
							defaultValue={'Find an auction item!'}
							alt=''
						/>
					</div>
					<div className={styles.stepText}>
						<h2>Choose your Item</h2>
						<p>
							Explore an exciting range of products, from the latest gadgets to
							unique collectibles. Simply pick the item that catches your eye
							and get ready to make your move!
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default StepOne;
